import React from 'react';
import { connect } from 'react-redux';
import '../../styles/play_styles.scss';
import axios from 'axios';
import Cookies from 'universal-cookie';
import Footer from './play_Footer';
import Navbar from './play_Navbar';
import { Navigate } from 'react-router-dom';
import { setResultObject, setPromoState } from '../../actions';
import Modal from '../../modal/default';
import { ParticipationRegisterStatus } from './utils/ParticipationRegisterStatus';
import MyModal from '../../modal/newModal';
import config from '../../configuration.json';
class WinningMomentPage extends React.Component {

    state = {
        scale: false,
        useNavigation: null,
        
    };
    active = false;
    redirections = {};
    componentDidMount() {
        window.scrollTo(0, 0);
        if (!this.props.result || !this.props.result.code) {
            this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}`} replace={true} /> });
        }
        this.cookies = new Cookies();
        this.redirections[ParticipationRegisterStatus.ParticipationDataRegistered] = this.redirectThanks.bind(this);
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
        this.setState({ imageHover: config.PlayAndPizza.Participate.ImgInactive });
    }

    resize() {
        if (window.innerWidth <= 760) {
            this.setState({ scale: true });
        }
        else {
            this.setState({ scale: false });
        }
    }

    submitWinningMoment() {

        console.log('Winning moment submitted', this.props.result);

        let formData = new FormData();
        formData.append("Email", this.props.result.email);
        formData.append("Code", this.props.result.code);
        // this.showLoader();
        axios.post('api/momentoganador', formData, {
            withCredentials: true,
            headers: { Accept: "multipart/form-data", 'X-XSRF-TOKEN': this.cookies.get("XSRF-TOKEN") }
        }).then(response => {
                  
                console.log('Response from winning moment submission:', response);
        
                
            this.nextStep({ ...response.data,   email_: this.props.result.email, code_: this.props.result.code });
            // this.hideLoader();
            //this.enableSubmitButton();
            //const registerResult = response.data;

        }).catch((e) => {
            console.log(e);
            //this.hideLoader();
            this.handlerError()
        });
    }

    redirectThanks(registerResult) {
        this.props.setPromoState(ParticipationRegisterStatus.ParticipationDataRegistered);
        this.props.setResultObject(registerResult);
        this.setState({ useNavigation: <Navigate to={`/${process.env.REACT_APP_HOME}/gracias`} replace={true} /> });
    }
    nextStep(registerResult) {
        setTimeout(() => {
            this.redirections[registerResult.redirectTo]({ ...registerResult });
        }, 100);
    }

    handlerError() {
        this.setState({ renderModal: <MyModal title="Error" content="Ha ocurrido algún error inesperado. Vuelve a intentarlo más tarde" /> });
    }

    changeImageHover(isHover) {

        this.setState({ imageHover: config.PlayAndPizza.Participate[isHover ? "ImgActive" : "ImgInactive"] });
        if (!this.active) {
            this.active = true;
            setTimeout(() => {
                this.submitWinningMoment();
            }, 1300);
        }
    }

    render() {
        return (
            <div className='row'>
                {this.state.useNavigation}
                <Navbar image={config.PlayAndPizza.HeaderIconlUrl} />
                <div className=''>
                    <div className='play_title_wwmm text-center'>
                        <h3>{config.PlayAndPizza.Participate.Title}</h3>
                    </div>
                </div>
                <div>
                    <div onClick={() => {
                        window.gtag('event', 'participate', { 'eventCategory': 'wwmm', 'eventLabel': 'step2' });
                        this.changeImageHover(true);
                    }}>
                        <img src={this.state.imageHover} alt='Winning moment' className='play_image_wwmm mx-auto d-block' />
                    </div>
                </div>
                <div>
                    <div>
                        <p className='play_detail_wwmm text-center'>{config.PlayAndPizza.Participate.Detail}</p>
                    </div>
                    <div className='play_footer_wwmm'>
                        <img src={config.PlayAndPizza.Participate.Imgfooter} alt='Winning moment' className='play_image_wwmm mx-auto d-block' />
                    </div>
                </div>
                {this.state.renderModal}
                <Footer footerName="thank-you-footer" />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        result: state.pageReducer.result,
    };
};

export default connect(mapStateToProps, { setResultObject, setPromoState })(WinningMomentPage);


